<div id="background_loader" *ngIf="background_loader==true">
    <div class="background_loader_inner">
        <div class="spinner"></div>
        <div class="loading-text">Procesando...</div>
    </div>
</div>


<app-main-header class="header" [name_main]="titleheader" [goBack]="true">
     @if(creating){
        <button class="btn-header" mat-flat-button color="primary" (click)="loadFiles()">Guardar</button>
    } @else {
    }
</app-main-header>


<div class="task-container">
    <div class="create-task">
        <form [formGroup]="AnnotationsForm">
            @for (d of formConfig; track d.label; let idx = $index, e = $even) {
            <mat-form-field appearance="outline"
                [ngStyle]="{ 'width': d.width, 'margin':d.margin}">
                <mat-label>{{ d.label }}</mat-label>
                <input matInput [formControlName]="d.controlName" [type]="d.type">
            </mat-form-field>
            }
        </form>
    </div>

    <div class="recog">
        @if(listModels$ | async; as models){
        <app-search-autocomplete [icon]="'models'" [items]="models"
            [placeholder]="'Buscar modelos de reconocimiento...'" (itemSelected)="onItemSelected($event)"
            [disableStyle]="true">
        </app-search-autocomplete>
        }

        @if(annotation$ | async; as annotation){
        <p-table class="table-within-gray" [value]="annotation.models!" emptyMessage="No hay datos disponibles"
            [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
                <tr style="font-size: 12px;">
                    <th>Id</th>
                    <th>Nombre</th>
                    <th>Ruta</th>
                    <th>Descripción</th>
                    <th pSortableColumn></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-models>
                <tr style="font-size: 12px;">
                    <td>{{ models.model.model_id }}</td>
                    <td>{{ models.model.name }}</td>
                    <td>{{models.model.server_path}}</td>
                    <td>{{models.model.description}}</td>
                    <td>
                        <button mat-icon-button [matMenuTriggerFor]="menu1">
                            <span class="material-symbols-outlined">more_vert</span>
                        </button>
                        <mat-menu #menu1="matMenu">
                            <button mat-menu-item>
                                <span class="material-symbols-outlined" (click)="removeModel(models)">delete</span>
                                <span>Eliminar</span>
                            </button>
                        </mat-menu>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        }@else{
        <div class="contone">
            <img width="80" src="assets/icons/no_model.svg" alt="">
            No hay modelos seleccionados
        </div>
        }
    </div>
    
    <ng-container *ngIf="creating; else editTask">
    <div class="upload-header">
            <h2>Imágenes</h2>
            <div class="upload-buttons">
                <button mat-raised-button class="upload-button" (click)="fileInput.click()">
                    Cargar imágenes
                    <input #fileInput hidden type="file" accept="image/*" multiple (change)="eventImage($event)" />
                </button>

                <button mat-raised-button class="upload-button" (click)="fileInputCsv.click()">
                    Cargar CSV
                    <input #fileInputCsv hidden type="file" accept=".csv" multiple (change)="eventCsv($event)" />
                </button>
            </div>
        </div>
        
    <div class="upload-images ">
        <div class="file-preview" *ngIf="fileDisplayText">
            <mat-icon color="primary">insert_drive_file</mat-icon>
            <span>{{ fileDisplayText }}</span>
        </div>
    </div>
  </ng-container>

    <ng-template #editTask>  
    <div class="jobs-header">
      <h2>Trabajos</h2>
      <button mat-flat-button color="primary" (click)="onRetryProcess()"> Reintentar</button>
      </div>
      <div *ngIf="jobs$ | async as jobs">
        <div *ngFor="let job of jobs" class="job-box">
          Job #{{ job.id }}
        </div>
      </div>
  </ng-template>
</div>